import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '~/api/errors';
import { queryKeys } from '~/api/queryKeys';
import { fullJitterRetryDelay, jitteredStaleTime } from '~/utils/jitter';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Ky's built-in retry is off (see `client.ts`), so this is the single
        // retry layer for query-backed reads. Retry 5xx, network/timeout errors
        // (non-ApiError), and the two transient 4xx Ky used to cover — 408
        // (request timeout) and 429 (rate limit). Fail fast on every other 4xx.
        if (
          error instanceof ApiError &&
          error.statusCode !== null &&
          error.statusCode < 500 &&
          error.statusCode !== 408 &&
          error.statusCode !== 429
        ) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: false,
    },
  },
});

// ----- catalog-v2 -----
/**
 * catalog-v2 reads (every key under `catalog-service`): retries wait with exponential backoff and
 * full jitter, and the default 5-minute staleTime is spread ±10% per query, so many tabs and rows
 * do not retry or refetch in step. The retry RULE (no retry on 4xx) is the default above.
 */
queryClient.setQueryDefaults(queryKeys.catalogService.all, {
  retryDelay: fullJitterRetryDelay,
  staleTime: jitteredStaleTime(5 * 60 * 1000),
});
// ----- end catalog-v2 -----
